import React, { useState } from 'react';
import { MailIcon, ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
export function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
    }
  }
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#1e3d2f'
  }} aria-label="Newsletter Signup" data-id="element-1897">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center" data-id="element-1898">
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-6" style={{
        backgroundColor: 'rgba(200,168,75,0.15)',
        border: '1px solid rgba(200,168,75,0.3)'
      }} data-id="element-1899">
          <MailIcon size={26} style={{
          color: '#c8a84b'
        }} data-id="element-1900" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold uppercase mb-4" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#ffffff'
      }} data-id="element-1901">
          Stay in the Loop
        </h2>
        <div className="section-divider-center" data-id="element-1902" />

        <p className="text-base leading-relaxed mb-4" style={{
        color: '#a0c8b0',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-1903">
          If you are not an FLSC Member, enter your email address below to sign
          up for our membership newsletter. Members are automatically included.
        </p>

        <a href="/FLSCNewsletter.html" className="inline-flex items-center gap-2 text-sm font-semibold mb-8 transition-colors hover:opacity-80" style={{
        color: '#c8a84b',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-1904">
          Read this month's FLSC Newsletter
          <ArrowRightIcon size={14} data-id="element-1905" />
        </a>

        {submitted ? <div className="flex items-center justify-center gap-3 p-5 rounded-xl" style={{
        backgroundColor: 'rgba(200,168,75,0.12)',
        border: '1px solid rgba(200,168,75,0.3)'
      }} data-id="element-1906">
            <CheckCircleIcon size={22} style={{
          color: '#c8a84b'
        }} data-id="element-1907" />
            <p className="text-base font-medium" style={{
          color: '#e8e4d8',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1908">
              You're signed up! Watch your inbox for FLSC news.
            </p>
          </div> : <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-id="element-1909">
            <div className="relative flex-1" data-id="element-1910">
              <MailIcon size={16} className="absolute left-4 top-1/2 -translate-y-1/2" style={{
            color: '#7a9a8a'
          }} data-id="element-1911" />
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required aria-label="Email address for newsletter" className="w-full pl-11 pr-4 py-3.5 rounded-lg text-sm outline-none" style={{
            backgroundColor: 'rgba(255,255,255,0.08)',
            border: '1px solid rgba(255,255,255,0.15)',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1912" />
            </div>
            <button type="submit" className="px-6 py-3.5 rounded-lg font-semibold text-sm transition-all hover:opacity-90 whitespace-nowrap" style={{
          backgroundColor: '#c8a84b',
          color: '#1a1a1a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1913">
              Subscribe
            </button>
          </form>}

        <p className="mt-4 text-xs" style={{
        color: '#5a7a6a',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-1914">
          No spam. Unsubscribe anytime in your membership profile.
        </p>
      </div>
    </section>;
}